import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import ImportBtn from '@/components/ImportBtn'
import { reactive, ref, computed } from 'vue'
import { customerLabelList } from '@/api/yuntuSales/customerLabelManage'
import CustomerLabelCascader from '@/components/CustomerLabelCascader/index.vue'
import CustomerLabelAddModel from './CustomerLabelAddModel.vue'


const __default__ = { name: 'DcCosLbuCustomerLabelManage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const tableRef = ref()
const queryForm = reactive({})
const addRef = ref()
const handleAdd = () => {
  addRef.value?.init()
}
const success = (type = 'edit') => {
  if (type === 'add') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await customerLabelList({ ...params })
  callBack(res)
}
const columns = computed(() => [
  { title: '客户名称', dataIndex: 'customerName' },
  { title: '客户ID', dataIndex: 'cosId', width: 200 },
  // { title: '原标签', dataIndex: 'lastLabel' },
  { title: '标签', dataIndex: 'label' },
  { title: '操作人', dataIndex: 'labelByName' },
  { title: '操作时间', dataIndex: 'labelTime', width: 150 }
])

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onFetch: fetch,
            search: queryForm,
            "onUpdate:search": _cache[8] || (_cache[8] = ($event: any) => ((queryForm) = $event)),
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosLbuCustomerLabelManage"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, { label: "客户名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.customerName) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户ID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.cosId,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.cosId) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "变更标签" }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerLabelCascader, {
                        appId: "cos_lbu",
                        onlyCommon: false,
                        value: queryForm.labelId,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.labelId) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "操作人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        value: queryForm.labelBy,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.labelBy) = $event)),
                        placeholder: "请选择",
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "操作时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: queryForm.startTime,
                        "onUpdate:startTime": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.startTime) = $event)),
                        endTime: queryForm.endTime,
                        "onUpdate:endTime": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.endTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (handleAdd()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("变更标签")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_customer_label_add_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_unref(ImportBtn), {
                action: "/lbu/api/clueCustomer/label/import",
                templateUrl: "/lbu/api/clueCustomer/label/template/download",
                onSuccess: _cache[7] || (_cache[7] = ($event: any) => (success('search')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导入")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_customer_label_import_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, record }) => [
              (column.dataIndex === 'label')
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(record.label ? record.label.map((item) => item.labelName ).join('、') : '--'), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"]),
          _createVNode(CustomerLabelAddModel, {
            ref_key: "addRef",
            ref: addRef,
            onFetch: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})